import { useCallback } from "react";
import { snackService } from "services";

type Severity = "success" | "error" | "warning" | "info";

interface SnackOptions {
  autoHideDuration?: number;
  anchorOrigin?: {
    vertical: "top" | "bottom";
    horizontal: "left" | "center" | "right";
  };
}

export const useSnack = () => ({
  openSnack: useCallback(
    (message: string, severity: Severity = "success", options: SnackOptions = {}) => {
      snackService.open(message, severity, options);
    },
    [],
  ),
  closeSnack: useCallback(() => snackService.close(), []),
});